import React from 'react';
import styled from 'styled-components';
import moment from "moment";
import $ from 'jquery';
import { findDOMNode } from 'react-dom';
import { useState, useRef } from 'react';
import { isMobileOnly } from 'react-device-detect';

const NoticeAccoLiBlock = styled.li`

`;

const NoticeAccoTitleboxBlock = styled.div`

`;

const NoticeAccoNumSpanBlock = styled.span`

`;
const NoticeAccoCateSpanBlock = styled.span`

`;

const NoticeAccoTitleH4Block = styled.h4`
    ${isMobileOnly&&`
        width : 50vw; /* 구식 브라우저를 위한 대비책(fallback) */
        width : -webkit-calc(100% - 180px); /* for Chrome, Safari */
        width : -moz-calc(100% - 180px); /* for Firefox */
        width : calc(100% - 180px); 
        display: block;
        float: left;
        padding: 28px 0;
    `};
`;

const NoticeAccoDateSpanBlock = styled.span`

`;

const NoticeAccoArrowSpanBlock = styled.span`

`;


const NoticeAccoConBoxBlock = styled.div`

`;

const NoticeAccoConBlock = styled.div`

`;

const CateOption = [
    { value: "all", label: "전체" },
    { value: "125201", label: "중요한 거" },
    { value: "125202", label: "재밌는 거" },
];

const NoticeAccoItem = ({ dataInfo, active, clickHandler}) => {
    const answerRef = useRef(null);

    const onClickTitle = ()=>{
        //console.log("onClickTitle")
        if(answerRef.current){
            const el = findDOMNode(answerRef.current);
            $(el).slideToggle();
            $(el).parents('li').toggleClass('active');
        }

    }

    const handleActiveClass = () => {
        if(answerRef.current){
            const el = findDOMNode(answerRef.current);
            if(active){
                $(el).slideDown();
                $(el).parents('li').addClass('active');
            }
            else {
                $(el).slideUp();
                $(el).parents('li').removeClass('active');
            }
        }
    }

    const getTitleCate = () => {
        for(var i =0 ; i < CateOption.length ; i++){
            if(dataInfo.ntc_type === CateOption[i].value){
                return CateOption[i].label;
            }
        }
    }

    if(dataInfo === null || dataInfo.answer === null || dataInfo.content === undefined) {
        return <div></div>
    }

    return (isMobileOnly ?
        <NoticeAccoLiBlock className={handleActiveClass()}>
            <NoticeAccoTitleboxBlock className="da-title-box clearfix" onClick = {() => clickHandler(dataInfo.id)}>
                <NoticeAccoNumSpanBlock className="da-cate" style={{ width: '30px', height:'70px' }}>
                    {dataInfo.row_number}
                </NoticeAccoNumSpanBlock>
                <NoticeAccoCateSpanBlock className="da-cate" style={{ width: 'fit-content', minWidth: '70px' }}>
                    [{getTitleCate()}]
                </NoticeAccoCateSpanBlock>
                <NoticeAccoTitleH4Block className="da-title22" style={{ paddingLeft: '1vw', paddingRight: '1vw' }}>
                    {dataInfo.title}
                </NoticeAccoTitleH4Block>
                <NoticeAccoDateSpanBlock className="da-date" style={{ width: '80px', textAlign: 'center' }}>
                    {moment(dataInfo.reg_dtm).format('YYYY.MM.DD')}
                </NoticeAccoDateSpanBlock>
                {/* <NoticeAccoArrowSpanBlock className="da-arrow" style={{ paddingTop: '20px', paddingBottom: '20px', width: '68px' }}></NoticeAccoArrowSpanBlock> */}
            </NoticeAccoTitleboxBlock>
            <NoticeAccoConBoxBlock ref={answerRef} className="da-con-box answer no-icon"
            style={{borderTop: '1px solid #eee', backgroundColor: '#f4f4f4', color: '#666', padding: '30px 3vw 30px 5vw'}}>
                <NoticeAccoConBlock className="da-con" style={{ paddingLeft: '1vw', paddingRight: '1vw' }} >
                    <div dangerouslySetInnerHTML={{ __html: dataInfo.content }} ></div>
                </NoticeAccoConBlock>
            </NoticeAccoConBoxBlock>
        </NoticeAccoLiBlock>
        :
        <NoticeAccoLiBlock className={handleActiveClass()}>
            <NoticeAccoTitleboxBlock className="da-title-box clearfix" onClick = {() => clickHandler(dataInfo.id)}>
                <NoticeAccoNumSpanBlock className="da-cate" style={{ width: '78px', height:'70px' }}>
                    {dataInfo.row_number}
                </NoticeAccoNumSpanBlock>
                <NoticeAccoCateSpanBlock className="da-cate" style={{ width: '110px' }}>
                    [{getTitleCate()}]
                </NoticeAccoCateSpanBlock>
                <NoticeAccoTitleH4Block className="da-title" style={{ width: '800px', paddingLeft: '20px', paddingRight: '20px'}}>
                    {dataInfo.title}
                </NoticeAccoTitleH4Block>
                <NoticeAccoDateSpanBlock className="da-date" style={{ width: '120px', textAlign: 'center' }}>
                    {moment(dataInfo.reg_dtm).format('YYYY.MM.DD')}
                </NoticeAccoDateSpanBlock>
                <NoticeAccoArrowSpanBlock className="da-arrow" style={{ paddingTop: '20px', paddingBottom: '20px', width: '68px' }}></NoticeAccoArrowSpanBlock>
            </NoticeAccoTitleboxBlock>
            <NoticeAccoConBoxBlock ref={answerRef} className="da-con-box answer no-icon"
            style={{borderTop: '1px solid #eee', backgroundColor: '#f4f4f4', color: '#666', paddingLeft: '208px', paddingRight: '208px'}}>
                <NoticeAccoConBlock className="da-con" >
                    <div dangerouslySetInnerHTML={{ __html: dataInfo.content }} ></div>
                </NoticeAccoConBlock>
            </NoticeAccoConBoxBlock>
        </NoticeAccoLiBlock>
        );
    /* return (
        <NoticeAccoLiBlock className={handleActiveClass()}>
            <NoticeAccoTitleboxBlock className="da-title-box clearfix" onClick = {() => clickHandler(dataInfo.id)}>
                <NoticeAccoNumSpanBlock className="da-cate" style={{ width: '78px', height:'70px' }}>
                    {dataInfo.row_number}
                </NoticeAccoNumSpanBlock>
                <NoticeAccoCateSpanBlock className="da-cate" style={{ width: '110px' }}>
                    [{getTitleCate()}]
                </NoticeAccoCateSpanBlock>
                <NoticeAccoTitleH4Block className="da-title" style={{ width: '800px', paddingLeft: '20px', paddingRight: '20px'}}>
                    {dataInfo.title}
                </NoticeAccoTitleH4Block>
                <NoticeAccoDateSpanBlock className="da-date" style={{ width: '120px', textAlign: 'center' }}>
                    {moment(dataInfo.reg_dtm).format('YYYY.MM.DD')}
                </NoticeAccoDateSpanBlock>
                <NoticeAccoArrowSpanBlock className="da-arrow" style={{ paddingTop: '20px', paddingBottom: '20px', width: '68px' }}></NoticeAccoArrowSpanBlock>
            </NoticeAccoTitleboxBlock>
            <NoticeAccoConBoxBlock ref={answerRef} className="da-con-box answer no-icon"
            style={{borderTop: '1px solid #eee', backgroundColor: '#f4f4f4', color: '#666', paddingLeft: '208px', paddingRight: '208px'}}>
                <NoticeAccoConBlock className="da-con" >
                    <div dangerouslySetInnerHTML={{ __html: dataInfo.content }} ></div>
                </NoticeAccoConBlock>
            </NoticeAccoConBoxBlock>
        </NoticeAccoLiBlock>
    ); */
};

export default NoticeAccoItem;
